import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1f32e610"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "snapshots" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "title" }, "Snapshots", -1))
const _hoisted_3 = { class: "snapshots__list" }
const _hoisted_4 = ["onClick"]
const _hoisted_5 = { class: "create-container" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "title mb-s" }, "Create new", -1))
const _hoisted_7 = /*#__PURE__*/_createTextVNode("Create")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_base_link = _resolveComponent("base-link")!
  const _component_base_input = _resolveComponent("base-input")!
  const _component_base_select = _resolveComponent("base-select")!
  const _component_base_button = _resolveComponent("base-button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", null, [
      _hoisted_2,
      _createElementVNode("ul", _hoisted_3, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.snapshots, (snapshot) => {
          return (_openBlock(), _createElementBlock("li", {
            key: snapshot.id,
            onClick: ($event: any) => (_ctx.activeSnapshotId = snapshot.id)
          }, [
            (snapshot.content)
              ? (_openBlock(), _createBlock(_component_base_link, {
                  key: 0,
                  to: { name: 'SnapshotDetails', params: { id: snapshot.id } },
                  text: snapshot.content.description
                }, null, 8, ["to", "text"]))
              : _createCommentVNode("", true)
          ], 8, _hoisted_4))
        }), 128))
      ])
    ]),
    _createElementVNode("div", _hoisted_5, [
      _hoisted_6,
      _createVNode(_component_base_input, {
        id: "work-order-number",
        type: "text",
        placeholder: "Work order number",
        modelValue: _ctx.requestId,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.requestId) = $event))
      }, null, 8, ["modelValue"]),
      _createVNode(_component_base_select, {
        modelValue: _ctx.selectedLanguage,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.selectedLanguage) = $event)),
        options: _ctx.languages
      }, null, 8, ["modelValue", "options"]),
      _createVNode(_component_base_button, {
        text: "Create",
        onClick: _ctx.createNewSnapshot
      }, {
        default: _withCtx(() => [
          _hoisted_7
        ]),
        _: 1
      }, 8, ["onClick"])
    ])
  ]))
}